module.exports = __webpack_public_path__ + "assets/img/65x_519.f9c07bf9.jpg";